import { FC } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import Swal from "sweetalert2";
import { Input } from "../../../components/inputs/inputs";
import api from "../../../services/api";
import { CustomerAddressProps } from "../newCustomer.types";


const CustomerAddress: FC<CustomerAddressProps> = ({
  setAddress,
  address,
  showCustomerAddress,
  setShowCustomerAddress,
  setLoading,
  stateAlarm,
  cityAlarm,
  streetAlarm,
  numberAlarm,
  zipCodeAlarm,
  bairroAlarm,
  extraAlarm,
  desactiveAlarms,
  customerAddresses,
}) => {
  async function findCep(cep: string, firstSearch?: boolean) {
    const data = customerAddresses.find(
      (el) => el.zipCode === cep.replace("-", ""),
    );

    if (data) {
      let zipCode = data.zipCode;
      let street = data.street;
      let number = data.number;
      let extra = data.extra;
      let district = data.district;
      let city = data.city;
      let state = data.state;
      let ibge = data.ibgeCode;
      setAddress({
        zipCode: zipCode,
        street: street,
        number: number,
        district: district,
        city: city,
        state: state,
        extra: extra,
        reference: "",
        typeAddress: "main",
        ibge: ibge,
      });

      return;
    }

    if (cep) {
      setLoading(true);
      return await api
        .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
        .then((response) => {
          if (response.data.erro) {
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "CEP inválido!",
              text: "Verifique se o CEP foi digitado corretamente.",
            });
            return false;
          } else {
            const data = response.data;

            setAddress({
              zipCode: data.cep,
              street: data.logradouro,
              number: "",
              district: data.bairro,
              city: data.localidade,
              state: data.uf,
              extra: "",
              reference: "",
              typeAddress: "main",
              ibge: data.ibge,
            });
            desactiveAlarms();
            setLoading(false);
            return true;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          setLoading(false);
          return false;
        });
    } else {
      return false;
    }
  }

  return (
    <div className="new-customer-address">
      <div className="title">
        <h3>Endereço de cadastro</h3>
        {showCustomerAddress ? (
          <BsChevronDown onClick={() => setShowCustomerAddress(false)} />
        ) : (
          <BsChevronUp onClick={() => setShowCustomerAddress(true)} />
        )}
      </div>
      {showCustomerAddress && (
        <>
          <Input
            inputAttr={{
              type: "cep",
            }}
            label="Cep"
            value={address.zipCode}
            warning={zipCodeAlarm}
            change={(value: string) => {
              setAddress({ ...address, zipCode: value });
            }}
            blur={(value) => findCep(value)}
          />

          <div className="two-inputs_equals">
            <Input
              inputAttr={{
                type: "select",
              }}
              label="Estado"
              value={address.state}
              warning={stateAlarm}
              change={(value: string) => {
                setAddress({ ...address, state: value });
              }}
            />
            <Input
              inputAttr={{
                type: "default",
              }}
              label="Cidade"
              placeholder="Cidade"
              value={address.city}
              warning={cityAlarm}
              change={(value: string) => {
                setAddress({ ...address, city: value });
              }}
            />
          </div>

          <div className="two-inputs_equals">
            <Input
              inputAttr={{
                type: "default",
              }}
              label="Endereço"
              value={address.street}
              placeholder="Rua das macarenas"
              change={(value: string) => {
                setAddress({ ...address, street: value });
              }}
              warning={streetAlarm}
            />
            <Input
              inputAttr={{
                type: "number",
              }}
              isSmall
              label="Número"
              placeholder="000"
              value={address.number}
              warning={numberAlarm}
              change={(value: string) => {
                setAddress({ ...address, number: value });
              }}
            />
          </div>
          <Input
            inputAttr={{
              type: "default",
            }}
            label="Bairro"
            value={address.district}
            warning={bairroAlarm}
            change={(value: string) => {
              setAddress({ ...address, district: value });
            }}
            placeholder="Bairro"
          />

          <Input
            inputAttr={{
              type: "default",
            }}
            label="Complemento (Opcional)"
            value={address.reference}
            change={(value: string) => {
              setAddress({ ...address, reference: value });
            }}
            placeholder="Complemento"
          />
          <Input
            inputAttr={{
              type: "default",
            }}
            label="Nome deste endereço"
            value={address.extra}
            warning={extraAlarm}
            change={(value: string) => {
              setAddress({ ...address, extra: value });
            }}
            placeholder="(Exemplo: casa, trabalho, etc)"
          />
        </>
      )}
    </div>
  );
};

export { CustomerAddress };